/**
 * Centralized navigation hooks to avoid circular dependencies
 * Components should import from this file instead of importing route configs that import components
 */
import { useNavigate } from 'react-router-dom';

export const useNavigateToDocket = () => {
  const navigate = useNavigate();
  return (guideId?: string) => {
    if (guideId && guideId !== 'none') {
      navigate(`/docket/guide/${guideId}`);
    } else {
      navigate('/docket');
    }
  };
};

export const useNavigateToMemberPage = () => {
  const navigate = useNavigate();
  return (
    guideId: string,
    memberId: string,
    noteId?: string,
    needId?: string
  ) => {
    const params = new URLSearchParams();
    if (noteId) params.append('note', noteId);
    if (needId) params.append('need', needId);

    const queryString = params.toString();
    const path = `/docket/guide/${guideId}/member/${memberId}`;
    navigate(queryString ? `${path}?${queryString}` : path);
  };
};

export const useNavigateToCalls = () => {
  const navigate = useNavigate();
  return (options?: { onlyUnassignedCalls?: boolean }) => {
    const params = new URLSearchParams();
    if (options?.onlyUnassignedCalls) {
      params.append('unassigned', 'true');
    }

    const queryString = params.toString();
    navigate(queryString ? `/calls?${queryString}` : '/calls');
  };
};
